import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/core/common-services/notification.service';
import { Language } from 'src/app/core/data-models/identity.data.models';

export interface CashStatementDialogData {
  investorId: string;
  type: 'excel' | 'pdf';
}

@Component({
  selector: 'app-cash-statement-dialog',
  templateUrl: './cash-statement-dialog.component.html',
  styleUrls: ['./cash-statement-dialog.component.css']
})
export class CashStatementDialogComponent implements OnInit {
  fromDate: Date | null = null;
  toDate: Date | null = null;
  maxDate: Date = new Date();
  fromDateError: string = '';
  toDateError: string = '';

  constructor(
    public dialogRef: MatDialogRef<CashStatementDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CashStatementDialogData,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {}

  // Live feedback while picking dates: only the cross-field order check, so the
  // "required" messages don't flash before the user has had a chance to fill both fields.
  onDateChange(): void {
    this.fromDateError = '';
    this.toDateError = this.fromDate && this.toDate && this.toDate < this.fromDate
      ? 'To Date cannot be earlier than From Date'
      : '';
  }

  // Disables the Download buttons only for a genuine order mismatch (both dates set,
  // To before From). An empty field stays clickable so the user gets the required message.
  get isDateOrderInvalid(): boolean {
    return !!this.fromDate && !!this.toDate && this.toDate < this.fromDate;
  }

  // Full check run on Download click, including required-ness.
  validateDates(): boolean {
    this.fromDateError = this.fromDate ? '' : 'From Date is required';
    this.toDateError = this.toDate ? '' : 'To Date is required';

    if (this.fromDate && this.toDate && this.toDate < this.fromDate) {
      this.toDateError = 'To Date cannot be earlier than From Date';
    }

    return !this.fromDateError && !this.toDateError;
  }

  download(language: 'ar' | 'en') {
    if (!this.validateDates()) {
      return;
    }

    const languageEnum: Language =
      language === 'ar' ? Language.Ar_SA : Language.En_US;

    this.dialogRef.close({
      fromDate: this.fromDate,
      toDate: this.toDate,
      language: languageEnum
    });
  }

  cancel() {
    this.dialogRef.close();
  }
}